module.exports = __webpack_public_path__ + "img/jujiupei@2x.929cbbdf.png";